import React from 'react'
import AsideShopComponent from './AsideShopComponent'
import WhatsappButton from '../component/WhatsappButton'
import BrandLogos from '../component/BrandLogos'

const CleanedShop = () => {
    return (

        <main className="main__content_wrapper">
            <section className="breadcrumb__section breadcrumb__bg">
                <div className="container-fluid">
                    <div className="row row-cols-1">
                        <div className="col">
                            <div className="breadcrumb__content">
                                <h1 className="breadcrumb__content--title text-white mb-10">Shop</h1 >
                                <ul className="breadcrumb__content--menu d-flex">
                                    <li className="breadcrumb__content--menu__items"><a className="text-white"
                                        href="/">Home</a ></li >
                                    <li className="breadcrumb__content--menu__items"><span className="text-white">Shop
                                    </span ></li >
                                </ul >
                            </div >
                        </div >
                    </div >
                </div >
            </section >

            <AsideShopComponent />
            <BrandLogos />
            <WhatsappButton />
        </main >
    )
}

export default CleanedShop